import { render, staticRenderFns } from "./RelatoriosIA.vue?vue&type=template&id=3b1df4cc&scoped=true"
import script from "./RelatoriosIA.vue?vue&type=script&lang=js"
export * from "./RelatoriosIA.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosIA.vue?vue&type=style&index=0&id=3b1df4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1df4cc",
  null
  
)

export default component.exports